// extracted by mini-css-extract-plugin
export default {"tags":"kZ7PYNzDpD38CRFSzLbD","participationsIcons":"bfFNe7dnYxPPK9UYhONq"};